module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.singleLoanMemberCollection), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.type === 'panulty') ? _c('i', [_vm._v("penalty")]) : _c('i', [_vm._v(_vm._s(row.type))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("myDate")(row.paymentDate)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("₹")]), _vm._v(_vm._s(row.amt) + "/-")]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.received_by) ? _c('span', [_vm._v(_vm._s(row.received_by.name))]) : _vm._e()]), _vm._v(" "), _c('td', [(row.branch_ledger) ? _c('span', [_vm._v(_vm._s(row.branch_ledger.ledger.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.status == 'pending') ? _c('span', [_c('i', {
      staticClass: "fa fa-exclamation-circle fa-2x text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e(), _vm._v(" "), (row.status == 'paid') ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Paid")]) : _vm._e(), _vm._v(" "), (row.status == 'approved') ? _c('span', [_c('i', {
      staticClass: "fa fa-check-circle fa-2x text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" "), (row.voucher.length === 0) ? _c('i', {
      staticClass: "fa fa-exclamation-triangle fa-2x text-danger",
      attrs: {
        "title": "Voucher Not Found",
        "aria-hidden": "true"
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (row.status == 'partial') ? _c('span', {
      staticClass: "label label-info"
    }, [_vm._v("Partial")]) : _vm._e()])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Collection Records")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Pay Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Received By")]), _vm._v(" "), _c('th', [_vm._v("Mode")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-45901de3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/SingleLoanPaymentRecords.vue
// module id = 857
// module chunks = 0